import React from "react";

const activationItems = [
  `Start driving within minutes <span style="font-weight: 500;">of signing up</span>`,
  `No waiting <span style="font-weight: 500;">for physical SIM cards to arrive in the mail</span>`,
  `No store visits required <span style="font-weight: 500;">- activate from anywhere</span>`,
  `Keep your current phone <span style="font-weight: 500;">running while you activate VLE Mobile</span>`,
  `Seamless transition <span style="font-weight: 500;">with no service interruption</span>`,
];

export const ESimActivation = () => {
  return (
    <section className="relative bg-[#04030A] px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 py-8 sm:py-10 md:py-12 lg:py-14 xl:pt-[3.62rem] xl:pb-0 overflow-hidden">
      <div className="flex flex-col xl:flex-row justify-center items-center gap-8 sm:gap-10 md:gap-14 lg:gap-16 xl:gap-32 2xl:gap-[11.735rem]">
        <div className="flex justify-end items-end">
          <div className="relative shrink-0 w-[95%] sm:w-full max-w-[17.5rem] sm:max-w-80 lg:max-w-[22.79256rem] aspect-[0.6715/1]">
            <img
              src="/assets/iPhone-13-Pro-Front-6.webp"
              alt="iPhone 13 Pro Front"
              className="relative z-[1] size-full"
            />
            <img
              src="/assets/iPhone-background.svg"
              alt="iPhone Background"
              className="absolute -left-[35%] -top-[4.825rem] sm:-top-[5.825rem] md:-top-[6.35rem] lg:-top-[7.35rem] xl:-top-[7.5rem] size-full"
            />
          </div>
        </div>
        <div className="flex flex-col items-center xl:items-start xl:self-start w-full xl:max-w-[43.75rem] xl:mt-[0.57rem]">
          <div className="text-center xl:text-left space-y-0.5 mb-4 sm:mb-6 lg:mb-8">
            <h2 className="font-mobile text-white text-[clamp(1.4375rem,calc(2.35vw+0.5rem),2.75rem)] font-normal leading-snug md:leading-normal lg:leading-[4rem]">
              Immediate eSIM Activation <br /> Get Connected in Minutes, Not
              Days
            </h2>
            <p className="text-[#707070] text-sm sm:text-[0.9375rem] lg:text-[1.0625rem] font-normal leading-5 sm:leading-[1.3125rem] lg:leading-[1.4rem] tracking-[-0.01063rem]">
              As a platform driver, time is money. VLE Mobile's instant eSIM
              activation means:
            </p>
          </div>
          <ul className="space-y-3 sm:space-y-3.5 lg:space-y-4 mb-3 sm:mb-3.5 lg:mb-4">
            {activationItems.map((item, index) => (
              <li
                key={index}
                className="flex items-center gap-2.5 sm:gap-3 lg:gap-4"
              >
                <img
                  src="/assets/tick-circle-green.svg"
                  alt="Tick"
                  className="size-5 sm:size-6 md:size-7 lg:size-8 shrink-0"
                />
                <p
                  className="text-white text-sm sm:text-[0.925rem] lg:text-base font-semibold leading-[1.1875rem] sm:leading-5 lg:leading-[1.4rem]"
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </li>
            ))}
          </ul>
          <span className="inline-block w-full xl:max-w-[32.1875rem] text-white text-sm sm:text-[0.925rem] lg:text-base font-semibold leading-5 sm:leading-[1.325rem] lg:leading-[1.4rem] mx-auto xl:mx-0">
            For platform drivers, this means no missed earnings while waiting
            for your new service to activate!
          </span>
        </div>
      </div>
    </section>
  );
};
